import React from "react";
import * as R from "ramda";
import { Div, Text3, CloseIcon } from "components/Base";
import { connect } from "react-redux";
import { getters } from "../model";
import { noop } from "utils/General";
import { getBackgroundColor } from "Portal/NewPortal/PortalHome/selectors";

const decorate = R.compose(
  connect(
    state => ({
      sessionData: getters.sessionData(state),
      backgroundColor: getBackgroundColor(state),
      contactDataInUse: getters.contactDataInUse(state)
    }),
    {}
  )
);

const Header = ({
  sessionData = {},
  hideModal = noop,
  backgroundColor = null,
  contactDataInUse = {}
}) => {
  if (!R.isEmpty(contactDataInUse)) return null;
  const { title = null } = sessionData || {};
  return (
    <Div
      style={{
        flexShrink: 0,
        borderBottom: "solid 1px #E7E6EA",
        ...(backgroundColor ? { backgroundColor } : {}),
        gap: "20px"
      }}
      display="row.space-between.center"
      px={5}
      py={3}
      brt={1}
      bra={0}
    >
      <Div flex={1}>
        <Text3 style={{ wordWrap: "break-word" }} bold>
          {title}
        </Text3>
      </Div>
      <Div onClick={hideModal} height={1} width={14}>
        <CloseIcon color={"neutral7"} sizeWFS={3} />
      </Div>
    </Div>
  );
};

export default decorate(Header);
